export default __webpack_public_path__ + "static/media/cross-icon.f0fef11c.svg";